export const CAMS_ACTIVATION_STATUS_QUERY = 'connectedDevices';